(function(window) {
  "use strict";
  if (window.AuxitoFitmentContext) {
    return;
  }
  var fitmentEngine = window.AuxitoFitmentEngine || null;
  var STORAGE_KEY = "auxito:product-fitment-context:v1";
  var MAX_SOURCE_URLS = 24;
  var MAX_HANDLES = 80;
  function createEmptyFilters() {
    return {
      bodyType: "",
      trim: "",
      qualifier: ""
    };
  }
  var dedupeStrings = fitmentEngine && typeof fitmentEngine.dedupeStrings === "function" ? fitmentEngine.dedupeStrings : function(items) {
    var seen = new Set;
    return (items || []).map(function(item) {
      return String(item || "").trim();
    }).filter(function(item) {
      if (!item || seen.has(item)) {
        return false;
      }
      seen.add(item);
      return true;
    });
  };
  var readJson = window.AuxitoUtils.readJson;
  var writeJson = window.AuxitoUtils.writeJson;
  function normalizeLocationGroups(raw) {
    if (!Array.isArray(raw) || !raw.length) {
      return null;
    }
    var groups = raw.map(function(g) {
      return {
        locationKey: String(g && g.locationKey || "").trim(),
        locationLabel: String(g && g.locationLabel || "").trim(),
        sourceUrls: dedupeStrings(Array.isArray(g && g.sourceUrls) ? g.sourceUrls : [])
      };
    }).filter(function(g) {
      return g.locationKey && g.sourceUrls.length;
    });
    return groups.length ? groups : null;
  }
  function normalize(payload) {
    var normalizedFilters;
    var normalizedSourceUrls;
    var normalizedHandles;
    if (!payload || typeof payload !== "object") {
      return null;
    }
    normalizedFilters = Object.assign(createEmptyFilters(), payload.filters || {});
    normalizedSourceUrls = dedupeStrings(Array.isArray(payload.sourceUrls) ? payload.sourceUrls : []);
    normalizedHandles = dedupeStrings(Array.isArray(payload.handles) ? payload.handles : []);
    if (!normalizedSourceUrls.length) {
      return null;
    }
    return {
      savedAt: Number(payload.savedAt || 0),
      recordKind: String(payload.recordKind || "").trim(),
      artifactsSignature: String(payload.artifactsSignature || "").trim(),
      queryCategory: String(payload.queryCategory || "").trim(),
      categorySlug: String(payload.categorySlug || "").trim(),
      locationKey: String(payload.locationKey || "").trim(),
      locationLabel: String(payload.locationLabel || "").trim(),
      year: String(payload.year || "").trim(),
      make: String(payload.make || "").trim(),
      model: String(payload.model || "").trim(),
      filters: normalizedFilters,
      sourceUrls: normalizedSourceUrls,
      handles: normalizedHandles,
      locationGroups: normalizeLocationGroups(payload.locationGroups || null)
    };
  }
  function collectHandles(products, limit) {
    var maxCount = Math.max(1, Number(limit || MAX_HANDLES) || MAX_HANDLES);
    return dedupeStrings((Array.isArray(products) ? products : []).map(function(product) {
      return product && product.handle ? product.handle : "";
    })).slice(0, maxCount);
  }
  function buildSelectionPayload(options) {
    var resolvedOptions = options && typeof options === "object" ? options : {};
    var record = resolvedOptions.record && typeof resolvedOptions.record === "object" ? resolvedOptions.record : {};
    var query = resolvedOptions.query && typeof resolvedOptions.query === "object" ? resolvedOptions.query : {};
    var filters = resolvedOptions.filters && typeof resolvedOptions.filters === "object" ? resolvedOptions.filters : {};
    var handles = Array.isArray(resolvedOptions.handles) ? resolvedOptions.handles : [];
    var sourceUrls = Array.isArray(resolvedOptions.sourceUrls) ? resolvedOptions.sourceUrls : [];
    return normalize({
      savedAt: Number(resolvedOptions.savedAt || Date.now()),
      recordKind: String(record.kind || resolvedOptions.recordKind || "").trim(),
      artifactsSignature: String(resolvedOptions.artifactsSignature || record.artifactsSignature || "").trim(),
      queryCategory: String(record.queryCategory || query.category || resolvedOptions.queryCategory || "").trim(),
      categorySlug: String(record.categorySlug || resolvedOptions.categorySlug || "").trim(),
      locationKey: String(record.locationKey || resolvedOptions.locationKey || "").trim(),
      locationLabel: String(record.location || resolvedOptions.locationLabel || "").trim(),
      year: String(query.year || resolvedOptions.year || "").trim(),
      make: String(query.make || resolvedOptions.make || "").trim(),
      model: String(query.model || resolvedOptions.model || "").trim(),
      filters: Object.assign(createEmptyFilters(), filters),
      sourceUrls: dedupeStrings(sourceUrls).slice(0, MAX_SOURCE_URLS),
      handles: dedupeStrings(handles).slice(0, MAX_HANDLES),
      locationGroups: Array.isArray(resolvedOptions.locationGroups) ? resolvedOptions.locationGroups : null
    });
  }
  function write(payload) {
    var normalized = normalize(payload);
    if (!normalized) {
      return null;
    }
    writeJson(window.sessionStorage, STORAGE_KEY, normalized);
    writeJson(window.localStorage, STORAGE_KEY, normalized);
    return normalized;
  }
  function read() {
    return normalize(readJson(window.sessionStorage, STORAGE_KEY) || readJson(window.localStorage, STORAGE_KEY));
  }
  function clear() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }
  function writeSelection(options) {
    var payload = buildSelectionPayload(options);
    if (!payload) {
      return null;
    }
    return write(payload);
  }
window.AuxitoFitmentContext={
    STORAGE_KEY: STORAGE_KEY,
    MAX_SOURCE_URLS: MAX_SOURCE_URLS,
    MAX_HANDLES: MAX_HANDLES,
    createEmptyFilters: createEmptyFilters,
    collectHandles: collectHandles,
    buildSelectionPayload: buildSelectionPayload,
    normalize: normalize,
    read: read,
    write: write,
    writeSelection: writeSelection,
    clear: clear
  };
})(window);
